import Sidebar from "Pages/Admin/Sidebar";
import React, { ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

interface AdminLayoutProps {
  children: ReactNode;
}
const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/admin" || location.pathname === "/admin/") {
      navigate("/admin/login");
    }
  }, []);

  // Exclude layout for login/signup
  if (location.pathname === "/admin/login") {
    return <>{children}</>;
  }

  return (
    <div className="dashboard-container">
      <Sidebar activeItem="dashboard" />
      {children}
    </div>
  );
};

export default AdminLayout;
